import { clsx } from 'clsx'

import { Dialog } from '@buffer-mono/popcorn'

import styles from './BulkPostDialog.module.css'

import type { JSX } from 'react'

/**
 * Ensures the body of the dialog is shared by the different steps
 */
export const BulkPostDialogBody = ({
  title,
  className,
  scrollable = false,
  children,
}: {
  title: string
  className?: string
  /** Allow the body to scroll vertically instead of clipping overflow */
  scrollable?: boolean
  children: React.ReactNode
}): JSX.Element => {
  return (
    <Dialog.Body
      className={clsx(
        styles.body,
        scrollable && styles.scrollableBody,
        className,
      )}
    >
      <Dialog.Title size="large">{title}</Dialog.Title>
      {children}
    </Dialog.Body>
  )
}
